export enum RateQuoteChargeUpliftRuleUnit {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT',
}

export namespace RateQuoteChargeUpliftRuleUnit {
  export function isValid(
    unit: string | undefined,
  ): unit is RateQuoteChargeUpliftRuleUnit {
    return unit
      ? Object.values(RateQuoteChargeUpliftRuleUnit).includes(
          unit as RateQuoteChargeUpliftRuleUnit,
        )
      : false;
  }

  /**
   * Parse and normalize uplift unit from string
   * Handles PERCENT_LINEHAUL (when uplift rule from lightning) by converting to PERCENT
   */
  export function parse(
    unit: string | undefined,
  ): RateQuoteChargeUpliftRuleUnit {
    if (!unit) {
      return RateQuoteChargeUpliftRuleUnit.FLAT;
    }

    if (unit === 'PERCENT_LINEHAUL') {
      return RateQuoteChargeUpliftRuleUnit.PERCENT;
    }

    return isValid(unit) ? unit : RateQuoteChargeUpliftRuleUnit.FLAT;
  }
}
